import type { Configurator } from "./configurator/Configurator";

export function persistSelection(cfg: Configurator) {
    const payload = JSON.stringify({ data: cfg.toSceneJson() });
    localStorage.setItem("selected", payload);
    const base = window.location.href.split("?")[0];
    history.replaceState(null, "", `${ base }?selected=${ payload }`);
}

export function loadSelectionFromLocation(): any[] | null {
    const url = new URL(window.location.href);
    const p = url.searchParams.get("selected");
    if (p) {
        try { return JSON.parse(p).data; }
        catch { /* ignore */ }
    }
    const ls = localStorage.getItem("selected");
    if (ls) {
        try { return JSON.parse(ls).data; }
        catch { /* ignore */ }
    }
    return null;
}
